// Capitalizes the first letter of a string
export const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

// Transmutes to pixel if value is number otherwise it keeps the string value as its expected to be percent
export const toPx = value => {
  if (typeof value === 'number') return `${value}px`;
  return value;
};
